import {Component, EventEmitter, Input, Output} from '@angular/core';
import {retry, takeUntil} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Subject} from 'rxjs';
import {CooperationService} from '../../service/cooperation.service';
import {OfficeAllocation} from '../../model/office-allocation.model';
import {CooperationPage} from '../../model/cooperation.model';

@Component({
  selector: 'app-recipient',
  templateUrl: './recipient.component.html',
  styleUrls: ['./recipient.component.scss']
})
export class RecipientComponent {

  LOCALSTORAGE_PREF_AGENT_KEY: string = 'preferredAgentId';

  constructor(private cooperationService: CooperationService, private httpClient: HttpClient) {
  }

  cancelSubscription: Subject<void> = new Subject<void>();

  @Input()
  set providerAgent(newAgent: OfficeAllocation) {
    this.currentProviderAgent = newAgent;
    this.preferredAgent = undefined;
    if (newAgent) {
      this.cancelSubscription.next();
      this.cooperations = [];
      this.cooperationService.getCooperationsByAgentId(newAgent.id).pipe(
        retry(10), takeUntil(this.cancelSubscription)).subscribe(page => {
        if (page?._embedded?.officeAllocations) {
          this.cooperations = this.sortByLastName(page._embedded.officeAllocations);
        }
        this.selectFirstAgent();
        this.loadingFirstPage = false;
        if (page?._links?.next) {
          this.loadingMorePages = true;
          this.loadCooperationPage(page._links.next.href);
        }
      });
    }
  }

  @Output()
  preferredAgentSelected: EventEmitter<OfficeAllocation> = new EventEmitter<OfficeAllocation>();

  cooperations: OfficeAllocation[];

  currentProviderAgent: OfficeAllocation;
  preferredAgent: OfficeAllocation;

  loadingFirstPage: boolean = true;
  loadingMorePages: boolean;

  public select(agent: OfficeAllocation) {
    this.preferredAgent = agent;
    this.preferredAgentSelected.emit(this.preferredAgent);
    this.storePreferredAgent();
  }

  sortByLastName(itemsToSort: OfficeAllocation[]): OfficeAllocation[] {
    return itemsToSort.sort((a, b) =>
      a._embedded.employee.lastName > b._embedded.employee.lastName ? 1 : -1);
  }

  loadCooperationPage(href: string) {
    this.httpClient.get<CooperationPage>(href).pipe(retry(10), takeUntil(this.cancelSubscription))
      .subscribe(page => {
        page?._embedded?.officeAllocations?.forEach(oa => this.cooperations.push(oa));
        this.cooperations = this.sortByLastName(this.cooperations);
        if (page?._links?.next) {
          this.loadCooperationPage(page._links.next.href);
        } else {
          this.loadingMorePages = false;
        }
      });
  }

  storePreferredAgent() {
    if (this.preferredAgent) {
      localStorage.setItem(this.LOCALSTORAGE_PREF_AGENT_KEY, this.preferredAgent.id);
    }
  }

  private selectFirstAgent() {
    const rememberedAgentId = localStorage.getItem(this.LOCALSTORAGE_PREF_AGENT_KEY);
    if (rememberedAgentId) {
      const indexOfRememberedAgent = this.cooperations.findIndex(oa => oa.id === rememberedAgentId);
      if (indexOfRememberedAgent >= 0) {
        this.select(this.cooperations[indexOfRememberedAgent]);
        return;
      }
    }
    if (this.cooperations?.length) {
      this.select(this.cooperations[0]);
    }
  }
}
